<template>
  <div class="p_pro_content">
    <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">项目名称</div>
                    <el-input v-model="listQuery.projectname" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                    <div class="flname">项目ID</div>
                    <el-input v-model="listQuery.projectid" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                    <el-button type="success" size="small" @click="searchHandle">搜索</el-button>
                </div>
            </div>
        </div>
        <!-- <div class="top-right">
            <el-button v-if="(isExport && this.tableData.length > 0)" type="warning" plain size="small" @click="exportHandle" :loading="btnLoading" :style="'margin-right:' +(!isExport && (tableData == [])?'0':'16px')">导出</el-button>
        </div> -->
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>客户</el-breadcrumb-item>
            <el-breadcrumb-item>项目</el-breadcrumb-item>
            <el-breadcrumb-item>商务合同提醒</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
      <div class="p_cus_table">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="全部" name="first"></el-tab-pane>
                <el-tab-pane label="合作中" name="second"></el-tab-pane>
                <el-tab-pane label="已暂停" name="third"></el-tab-pane>
            </el-tabs>
        <el-table v-loading="tableLoading" :highlight-current-row="true"  :max-height="tableHeight-100" :data="tableData" style="width:100%" stripe >
          <el-table-column align="center" label="项目ID" width="60px">
            <template slot-scope="{row}">
                <span>{{row.Projectid}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" fixed min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrprojectName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="立项时间" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{!isNullDate(row.DtInitDate) ? row.DtInitDate.substring(0,10):''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目状态">
            <template slot-scope="{row}">
              <span>{{row.StrBusiStat}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目终止时间" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{isNullDate(row.DtEndDate) ? '' : row.DtEndDate.substring(0,10)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="客户ID" width="60px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
                <span>{{row.Custid}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="客户简称" min-width="150px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrCustShortName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="客户名称" min-width="280px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrCustName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="所属集团名称" min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.strGroupName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="实操业务类型" min-width="150px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.ActualtypeName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目等级" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrCustprolevelName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="省份" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrProProvince}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目城市" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrProCity}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="业绩归属部门" min-width="200px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrbusdepName}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="业绩归属子部门" min-width="130px">
            <template slot-scope="{row}">
              <span>{{row.StrbussondepName}}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="center" label="业务团队长" min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrpartnerName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="合伙人" min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrpartnerName2}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="业绩归属人部门" min-width="200px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrAchievedepName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="业绩归属人" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrAchieveownerName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="一级部门" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrDep1Name}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="二级部门" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrDep2Name}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="三级部门" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrDep3Name}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="客服" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrservuseridName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目管理员" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrProManagerName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="是否招聘" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.Strrecruit}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="是否转移" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrTransfer}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="协议高风险" min-width="120px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrHighRisk}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="是否新增" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrNewadd}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="社保" min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.SocialInsurance}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="商保" min-width="140px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.BusInsurance}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="计提风险金" min-width="100px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.DecRiskfund}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="发票类型" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrBillmethod}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="开票方式" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrinvoiceType}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="开票内容" min-width="180px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrInvoicecontent}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="发薪日期" min-width="120px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{!isNullDate(row.Dtpaydate)?row.Dtpaydate.substring(0,10):''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="是否垫资" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.IsAdvMoney}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="签约主体" min-width="230px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrSignsubjectName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="合同业务类型" min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrContractTypeName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="合同起始时间" min-width="120px" fixed fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{!isNullDate(row.DtContractstartDate)?row.DtContractstartDate.substring(0,10):''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="合同到期时间" min-width="120px" fixed fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{!isNullDate(row.DtContractendDate)?row.DtContractendDate.substring(0,10):''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="合同负责人" min-width="120px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrContleaderName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="到期前60天提醒" min-width="130px" fixed fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span style="color:#F56C6C;">{{isOverdue(60, row.StrRemind60, row.DtContractendDate)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="创建时间" min-width="120px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{!isNullDate(row.DtInsertDate)?row.DtInsertDate.substring(0,10):''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目查看人" min-width="160px" fit show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.StrViewidsName}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="changeBPage"
            :current-page.sync="listQuery.currpage"
            :page-size="listQuery.perpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import xz from "@/common"
import moment from 'moment'
export default {
  name: "serviceCenter",
  data() {
    return {
        activeName:'first',
        // 列表参数
      listQuery:{
        projectname:'', // 项目名称
        projectid:'', // 项目id
        perpage: 10,
        currpage: 1,
        strorgancode:'',
        roletype:''
      },
      tableHeight:0,
      tableLoading:false,
      tableData:[],
      total:0
    }
  },
  created() {
    this.listQuery.roletype = localStorage.loginRoletype
    this.listQuery.strorgancode = localStorage.gancode
    this.getList()
    this.calHeight()
  },
  methods: {
      //切换tab
    async handleClick(tab, event) {
      // console.log('tab',tab, event)
      if(tab.label == '全部'){
        this.listQuery.strBusiStat = ''
      }else{
        this.listQuery.strBusiStat = tab.label
      }
      this.listQuery.currpage = 1
      this.getList()
    },
    isNullDate(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01'
    },
    // 提醒判断
    isOverdue(num, data, endDate){
        let timeNow = moment().format("YYYY-MM-DD")
      let timeEnd = moment(endDate).format("YYYY-MM-DD")
      if((Number(data) < num) && (Number(data) > 0) && (!this.isNullDate(endDate))){
        return '还有' + data + '天到期'
      }
      if(Number(data) < 0 && (!this.isNullDate(endDate))){
        return '已过期'
      }
      if(timeEnd == timeNow){
        return '已到期'
      }
      if(Number(data) > num || Number(data) == 0){
        return ''
      }
    },
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight)
    //   console.log('height',this.tableHeight)
    },
    // 搜索
    searchHandle(){
      this.listQuery.currpage = 1
      this.getList()
    },
    //分页
    changeBPage(val){
        this.listQuery.currpage = Number(val)
        this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.currpage = 1
      this.listQuery.perpage = Number(val)
      this.getList()
    },
    // 获取提醒列表
    getList(){
      this.tableLoading = true
      xz.getRemindProjectLists(this.listQuery).then(res => {
        // console.log('客户', res)
        if (res.status == 'ok') {
          this.tableData = res.msg
          this.total = res.totalcount
        } else {
          this.tableData = []
          this.total = 0
        }
        this.tableLoading = false
      })
    }
  }
}
</script>
<style>
.p_cus_table .el-tabs{
    background-color: #fff;
}
</style>